module.exports = __webpack_public_path__ + "img/channel-type-icon.19725d43.svg";